import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { getDialogConfig } from '../../../../../shared/utils/dialog.utils';
import { DashboardLogWeightedHarvestDialogComponent } from '../dashboard-log-weighted-harvest-dialog/dashboard-log-weighted-harvest-dialog.component';
import { DashboardQuickActionDialogComponent } from '../dashboard-quick-action-dialog/dashboard-quick-action-dialog.component';
import { DashboardRegisterShoppingDialogComponent } from '../dashboard-register-shopping-dialog/dashboard-register-shopping-dialog.component';
import { DashboardVolatileStockComponent } from '../dashboard-volatile-stock/dashboard-volatile-stock.component';

@Component({
  selector: 'app-dashboard-actions',
  templateUrl: './dashboard-actions.component.html',
  styleUrl: './dashboard-actions.component.scss',
})
export class DashboardActionsComponent {
  constructor(private matDialog: MatDialog) {}

  openQuickActionDialog(): void {
    this.matDialog.open(DashboardQuickActionDialogComponent, getDialogConfig({ minWidth: '60%' }));
  }

  openRegisterShoppingDialog(): void {
    this.matDialog.open(DashboardRegisterShoppingDialogComponent, getDialogConfig({ minWidth: '80%' }));
  }

  openVolatileStockDialog(): void {
    this.matDialog.open(DashboardVolatileStockComponent, getDialogConfig({ minWidth: '80%' }));
  }

  openLogWeightedHarvestDialog(): void {
    this.matDialog.open(DashboardLogWeightedHarvestDialogComponent, getDialogConfig({ minWidth: '60%' }));
  }
}
